import { NgModule } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { AppSharedModule } from '../../app-shared.module';
import { AppChatComponent } from './app-chat.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { MessageAttachmentComponent } from './chat-message/message-attachment/message-attachment.component';
import { ChatUploadComponent } from './chat-upload/chat-upload.component';

@NgModule({
	declarations: [
		AppChatComponent,
		ChatUploadComponent,
		ChatMessageComponent,
		MessageAttachmentComponent,
	],
	imports: [AppSharedModule, NgScrollbarModule],
	exports: [AppChatComponent, ChatUploadComponent, ChatMessageComponent],
	providers: [],
})
export class AppChatModule {}
